function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 6C9.25 4.20312 7.79688 2.75 6 2.75C4.20312 2.75 2.75 4.20312 2.75 6C2.75 7.79688 4.20312 9.25 6 9.25C7.79688 9.25 9.25 7.79688 9.25 6ZM2 6C2 3.79688 3.79688 2 6 2C8.20312 2 10 3.79688 10 6C10 8.20312 8.20312 10 6 10C3.79688 10 2 8.20312 2 6ZM5.625 3.875C5.625 3.67188 5.79688 3.5 6 3.5C6.20312 3.5 6.375 3.67188 6.375 3.875V5.79688L7.70312 6.6875C7.875 6.79688 7.92188 7.03125 7.8125 7.20312C7.70312 7.375 7.46875 7.42188 7.29688 7.3125L5.79688 6.3125C5.6875 6.25 5.625 6.125 5.625 6V3.875Z",
  fill: "currentColor"
});

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.68a1e874.svg";
export { ForwardRef as ReactComponent };